module.exports = __webpack_public_path__ + "img/vip2.efa5bf38.png";